<app-select-filter [parentFormGroup]="parentFormGroup"
                   [parentFormControlName]="parentFormControlName"
                   [noEntriesFoundLabel]="noValueLabel"
                   [filterElementProcessor]="filter"
                   [elements]="elements"
                   (_onSingleSelectionChange)="selectionChangedEvent?.emit($event.element)"
                   [loading]="loading">
  <ng-template template-content let-element='element'>
    <strong> {{element.businessId}}</strong> - {{element.patientName}} {{element.color.label}}
  </ng-template>
</app-select-filter>
